// extracted by mini-css-extract-plugin
export default {"card":"KanbanCard_card__MGaQO","title":"KanbanCard_title__L54Iv","issues-container":"KanbanCard_issues-container__vtdjB"};